(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["wakeme-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('wake-me-hero')) {
    customElements.define('wake-me-hero', class extends HTMLElement {
      connectedCallback() {
        this.schedule = () => {
          cancelAnimationFrame(this.frame);
          this.frame = requestAnimationFrame(() => this.layout());
        };
        window.addEventListener('resize', this.schedule, { passive: true });
        window.addEventListener('load', this.schedule);
        document.addEventListener('shopify:section:reorder', this.schedule);
        this.schedule();
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.frame);
        window.removeEventListener('resize', this.schedule);
        window.removeEventListener('load', this.schedule);
        document.removeEventListener('shopify:section:reorder', this.schedule);
      }

      layout() {
        if (!this.isConnected) return;
        // Överlägget är aktivt direkt i HTML. Vi beräknar bara sidhuvudets offset
        // om skärmhöjd används, och ändrar aldrig textens layout med JavaScript.
        const mobile = window.matchMedia('(max-width: 767px)').matches;
        const screenHeight = mobile
          ? this.dataset.mobileHeight === 'screen'
          : this.dataset.desktopHeight === 'screen';
        if (!screenHeight) return;

        const top = Math.max(0, this.getBoundingClientRect().top + window.scrollY);
        this.style.setProperty('--wm-top-offset', `${Math.round(top)}px`);
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
